import { Settings } from "../Components/index.js";

export default [{ path: "/admin/store/setting/group", component: Settings, name: "store.setting.group" }];
